module.exports = __webpack_public_path__ + "img/cloth_g1_pants_06.c62fbee8.svg";